import { DOCUMENT, Injectable, inject } from '@angular/core';
import { Meta, DomSanitizer } from '@angular/platform-browser';

export interface ArticleMetaData {
  title: string;
  url: string;
  image?: string;
  description: string;
}

@Injectable({
  providedIn: 'root',
})
export class MetaTagsService {
  private meta = inject(Meta);
  private sanitizer = inject(DomSanitizer);
  private document = inject(DOCUMENT);

  public setArticleMetaTags(data: ArticleMetaData): void {
    this.meta.updateTag({ property: 'og:title', content: data.title });
    this.meta.updateTag({ property: 'og:type', content: 'article' });
    this.meta.updateTag({ property: 'og:url', content: data.url });

    if (data.image) {
      this.meta.updateTag({ property: 'og:image', content: data.image });
    }

    this.meta.updateTag({ property: 'og:description', content: data.description });
  }

  public removeArticleMetaTags(): void {
    this.meta.removeTag('property="og:title"');
    this.meta.removeTag('property="og:type"');
    this.meta.removeTag('property="og:url"');
    this.meta.removeTag('property="og:image"');
    this.meta.removeTag('property="og:description"');
  }

  public extractDescription(htmlContent: string, maxLength: number = 200): string {
    if (!htmlContent) return '';

    const sanitizedHtml = this.sanitizer.sanitize(1, htmlContent) || '';

    const tempDiv = this.document.createElement('div');
    tempDiv.innerHTML = sanitizedHtml;

    let text = tempDiv.textContent || tempDiv.innerText || '';

    text = text.replace(/\s+/g, ' ').trim();

    if (text.length > maxLength) {
      text = text.substring(0, maxLength);
      const lastSpaceIndex = text.lastIndexOf(' ');
      if (lastSpaceIndex > 0) {
        text = text.substring(0, lastSpaceIndex);
      }
      text += '...';
    }

    return text;
  }
}
